/**
 * Long-tap (long-press) на заголовке статьи (.zaglavie) → action sheet
 * с действиями по статье: «Отправить себе в Telegram», «Редактировать»
 * (только админ — по наличию .edit-entry-btn), «Поделиться…» (navigator.share),
 * «Отмена». Инлайн-кнопки .tg-send-btn / .edit-entry-btn на touch-устройствах
 * скрыты (term-actions.css) — их роль полностью переходит в это меню; кнопка
 * отправки остаётся видимой только как транзиентный индикатор (sending/ok/err).
 *
 * Методология жеста — правило 40-frontend/p_40-longpress.md (боевой playbook):
 * long-press НИКОГДА не выполняет действие сразу, только открывает sheet;
 * порог 550мс (строго больше ~500мс ОС-порога); матрица подавления нативных
 * реакций ОС (callout/contextmenu/selection); проглатывание синтетического
 * click; защита от sticky hover WebKit при закрытии sheet и после share.
 *
 * Модуль активен ТОЛЬКО на touch-устройствах — десктоп (hover-reveal кнопки,
 * правый клик, выделение) не затронут.
 */
(function () {
  'use strict';

  var LONG_PRESS_MS = 550;  // строго > ~500мс — ОС-жесты должны подавляться, а не опережаться
  var MOVE_CANCEL_PX = 12;  // палец ушёл дальше — это скролл, не удержание
  var HOVER_GUARD_MS = 400; // окно подавления пересчёта sticky hover (WebKit)
  var VIBRATE_MS = 25;

  var isTouch = window.matchMedia
    && window.matchMedia('(hover: none), (pointer: coarse)').matches;
  if (!isTouch) return;

  var pressing = false;   // палец прижат к .zaglavie (для selectstart)
  var fired = false;      // long-press сработал — дожёвываем touchend/click
  var timer = null;
  var startX = 0;
  var startY = 0;
  var pressedZaglavie = null;

  function cancelTimer() {
    if (timer) { clearTimeout(timer); timer = null; }
  }

  function texts() {
    var lang = 'en';
    try {
      if (window.SEARCH_LANGUAGE && window.SEARCH_LANGUAGE.getCurrentLang) {
        lang = window.SEARCH_LANGUAGE.getCurrentLang();
      }
    } catch (e) { /* default en */ }
    return (window.LANG_TEXTS && window.LANG_TEXTS[lang]) || {};
  }

  // ---- sticky hover guard (WebKit): blur + мёртвая зона pointer-events ----
  // При удалении hovered-элемента из DOM WebKit пересчитывает hover по
  // координатам последнего касания — подсветилась бы строка под кнопкой sheet.
  // Побочный эффект: тапы по результатам «мёртвые» первые ~400мс после
  // закрытия sheet — палец за это время физически не успевает вернуться.
  function hoverGuard() {
    try {
      if (document.activeElement && document.activeElement.blur) {
        document.activeElement.blur();
      }
      var container = document.getElementById('results-container');
      if (container) {
        container.style.pointerEvents = 'none';
        setTimeout(function () { container.style.pointerEvents = ''; }, HOVER_GUARD_MS);
      }
    } catch (e) { /* guard is best-effort */ }
  }

  // ---- action sheet ----

  function closeSheet() {
    var overlay = document.querySelector('.term-action-sheet-overlay');
    if (overlay) overlay.remove();
    hoverGuard();
  }

  function buildBtn(cls, iconCls, label) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'term-action-sheet-btn' + (cls ? ' ' + cls : '');
    if (iconCls) {
      var icon = document.createElement('i');
      icon.className = iconCls;
      icon.setAttribute('aria-hidden', 'true');
      btn.appendChild(icon);
    }
    btn.appendChild(document.createTextNode(label));
    return btn;
  }

  function openSheet(zaglavie) {
    closeSheet();
    var t = texts();
    var article = zaglavie.closest('.opredelenie');
    var termEl = zaglavie.querySelector('.terms');
    var term = termEl ? termEl.textContent.trim() : '';
    var guid = article ? (article.getAttribute('data-guid') || '') : '';
    var tgSendBtn = zaglavie.querySelector('.tg-send-btn');
    var editBtn = zaglavie.querySelector('.edit-entry-btn');
    var historyBtn = zaglavie.querySelector('.revision-history-btn');
    var tgLinked = document.body.classList.contains('tg-linked');

    var overlay = document.createElement('div');
    overlay.className = 'term-action-sheet-overlay';

    var sheet = document.createElement('div');
    sheet.className = 'term-action-sheet';
    sheet.setAttribute('role', 'menu');

    // Заголовок = термин: пользователь верифицирует, ЧТО он держал
    // (палец закрывал строку в момент жеста).
    if (term) {
      var title = document.createElement('div');
      title.className = 'term-action-sheet-title';
      title.textContent = term;
      sheet.appendChild(title);
    }

    if (tgLinked && guid && tgSendBtn) {
      var sendLabel = t.tg_send_term_title || 'Send to my Telegram';
      var sendBtn = buildBtn('', 'bi bi-send', sendLabel);
      sendBtn.addEventListener('click', function () {
        closeSheet();
        // Существующий делегированный обработчик account.js; обратная связь —
        // транзиентный индикатор на самой строке (sending → галка/крест,
        // term-actions.css временно показывает кнопку в этих состояниях).
        tgSendBtn.click();
      });
      sheet.appendChild(sendBtn);
    }

    if (editBtn) {
      var editLabel = t.term_menu_edit || 'Edit';
      var editButton = buildBtn('', 'bi bi-pencil', editLabel);
      editButton.addEventListener('click', function () {
        closeSheet();
        editBtn.click(); // открывает WYSIWYG-редактор (editor/events.js)
      });
      sheet.appendChild(editButton);
    }

    if (historyBtn) {
      var historyButton = buildBtn('', 'bi bi-clock-history', historyBtn.textContent.trim());
      historyButton.addEventListener('click', function () {
        closeSheet();
        historyBtn.click();
      });
      sheet.appendChild(historyButton);
    }

    // Компенсация потерянного нативного long-press меню: системный share
    // отдаёт копирование ссылки / открытие в новой вкладке.
    if (navigator.share && term) {
      var shareLabel = t.term_menu_share || 'Share…';
      var shareBtn = buildBtn('', 'bi bi-box-arrow-up', shareLabel);
      shareBtn.addEventListener('click', function () {
        closeSheet();
        var lang = 'en';
        try {
          if (window.SEARCH_LANGUAGE && window.SEARCH_LANGUAGE.getCurrentLang) {
            lang = window.SEARCH_LANGUAGE.getCurrentLang();
          }
        } catch (e) { /* default */ }
        var url = location.origin + '/' + lang + '/?search='
          + encodeURIComponent(term.toLowerCase());
        // Пересчёт sticky hover происходит ЕЩЁ РАЗ при закрытии системного
        // share-меню (секунды спустя) — повторяем защиту на оба исхода.
        navigator.share({ title: term, url: url }).then(hoverGuard, hoverGuard);
      });
      sheet.appendChild(shareBtn);
    }

    // Нет ни одного действия (аноним без navigator.share) — пустое меню
    // из одной «Отмены» бессмысленно, жест просто игнорируем.
    if (!sheet.querySelector('.term-action-sheet-btn')) return;

    var cancelBtn = buildBtn('is-cancel', '', t.btn_cancel || 'Cancel');
    cancelBtn.addEventListener('click', closeSheet);
    sheet.appendChild(cancelBtn);

    overlay.appendChild(sheet);
    overlay.addEventListener('click', function (ev) {
      if (ev.target === overlay) closeSheet();
    });
    document.body.appendChild(overlay);
  }

  // ---- движок жеста ----

  function fire() {
    timer = null;
    fired = true;
    try { if (navigator.vibrate) navigator.vibrate(VIBRATE_MS); } catch (e) { /* iOS */ }
    // Снять то, что ОС успела выделить в гонке до нашего порога.
    try {
      var sel = window.getSelection && window.getSelection();
      if (sel && sel.removeAllRanges) sel.removeAllRanges();
    } catch (e) { /* best-effort */ }
    if (pressedZaglavie) openSheet(pressedZaglavie);
  }

  document.addEventListener('touchstart', function (ev) {
    fired = false; // стрелявший flag не должен пережить следующий жест
    if (ev.touches.length !== 1) { cancelTimer(); return; }
    var z = ev.target.closest && ev.target.closest('.opredelenie .zaglavie');
    if (!z) return;
    pressedZaglavie = z;
    pressing = true;
    startX = ev.touches[0].clientX;
    startY = ev.touches[0].clientY;
    cancelTimer();
    timer = setTimeout(fire, LONG_PRESS_MS);
  }, { passive: true });

  document.addEventListener('touchmove', function (ev) {
    if (!timer || !ev.touches.length) return;
    var dx = Math.abs(ev.touches[0].clientX - startX);
    var dy = Math.abs(ev.touches[0].clientY - startY);
    if (dx > MOVE_CANCEL_PX || dy > MOVE_CANCEL_PX) {
      cancelTimer(); // пользователь скроллит, а не держит
    }
  }, { passive: true });

  document.addEventListener('touchend', function (ev) {
    pressing = false;
    cancelTimer();
    if (fired) ev.preventDefault(); // не дать жесту провалиться в навигацию/аккордеон
  }, { passive: false });

  document.addEventListener('touchcancel', function () {
    pressing = false;
    cancelTimer();
  }, { passive: true });

  // Android: нативное контекстное меню всплывает на ~500мс — РАНЬШЕ нашего
  // таймера, поэтому preventDefault безусловный (модуль живёт только на touch,
  // десктопный правый клик не задет).
  document.addEventListener('contextmenu', function (ev) {
    if (ev.target.closest && ev.target.closest('.opredelenie .zaglavie')) {
      ev.preventDefault();
    }
  });

  // Выделение текста стартует тоже на ~500мс — душим, пока палец прижат.
  // CSS-уровень (user-select: none в term-actions.css) обязателен для WebKit.
  document.addEventListener('selectstart', function (ev) {
    if (pressing) ev.preventDefault();
  });

  // Синтетический click после consumed long-press — проглотить (capture,
  // раньше обработчика аккордеона), иначе тап «провалится» в .zaglavie.
  document.addEventListener('click', function (ev) {
    if (fired) {
      ev.preventDefault();
      ev.stopImmediatePropagation();
      fired = false;
    }
  }, true);
})();
